/* eslint-disable */
import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';

export const useProductStore = defineStore('product', {
  state: () => ({
    latestProductIdData: useStorage('piniaLatestProductId', ''),
    productIdData: useStorage('piniaProductId', ''),
    workflowData: useStorage<any>('piniaWorkflow', {} as any)
  }),
  getters: {
    latestProductId: (state) => {
      return state.latestProductIdData ? state.latestProductIdData : null;
    },
    productId: (state) => {
      return !!state.productIdData ? state.productIdData : null;
    },
    workflow: (state) => {
      return !!state.workflowData?.name ? state.workflowData : null;
    }
  },
  actions: {
    updateProductId(productId: string) {
      this.latestProductIdData = productId;
      this.productIdData = productId;
    },
    updateWorkflow(workflow: any) {
      this.workflowData = workflow;
    }
  }
});
